export default {"src":"/_next/static/media/google-play.1bee299f.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};